import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, ModalBody } from 'reactstrap';
import { fetchLogin } from './../actions/postLogin';
import { Loader } from './../../../components/loader';
import { parsePhone } from '../../../functions/phone';
import { RegistrationLink } from './registration';
import { ResetLink } from './reset';

function parseProps(props) {
    return {
        phone: parsePhone(props.phone),
        email: props.email || '',
        password: props.password || '',
    };
}

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = parseProps(props);
        this.confirmAction = this.confirmAction.bind(this);
        this.modalLine = this.modalLine.bind(this);
        this.changeInput = this.changeInput.bind(this);
        this.editPhone = this.editPhone.bind(this);
    }

    editPhone(status, value, countryData, number) {
        this.setState({
            phone: parsePhone(value, countryData.iso2),
        });
    }

    confirmAction() {
        let state = this.state;
        let props = this.props;
        const { dispatch } = props;
        let data = {
            email: state.email,
            phone: state.phone,
            password: state.password,
        };
        dispatch(fetchLogin(data, props.onAfterLogin));
    }

    modalLine(content) {
        return <div className="modal-line mt-4">{content()}</div>;
    }

    changeInput(event) {
        let id = event.target.id;
        let state = {};
        state[id] = event.target.value;
        this.setState({ ...state });
    }

    render() {
        const props = this.props,
            state = this.state,
            isFetching = props.modal.isFetching;

        return (
            <div>
                <div className="modal-scroll">
                    {isFetching ? <Loader /> : null}
                    <ModalBody>
                        {this.modalLine(() => (
                            <Input
                                value={state.email}
                                placeholder="Почта"
                                id={'email'}
                                onChange={this.changeInput}
                            />
                        ))}
                        {this.modalLine(() => (
                            <Input
                                type="password"
                                placeholder="Пароль"
                                id={'password'}
                                value={state.password}
                                onChange={this.changeInput}
                            />
                        ))}
                        <div className="w-100 text-right">
                            <a href="#" onClick={props.openReset}>
                                Забыли пароль?
                            </a>
                        </div>
                        <div className="submit-button-container position-relative mt-4">
                            <div
                                className="button mt-2 pointer-no-select"
                                onClick={() => {
                                    props.openRegistration(props.onAfterLogin);
                                }}
                            >
                                Регистрация
                            </div>
                            <div
                                className="submit-button mt-2 pointer-no-select"
                                onClick={this.confirmAction}
                            >
                                Войти
                            </div>
                        </div>
                    </ModalBody>
                </div>
            </div>
        );
    }
}

const MapStateToProps = function mapStateToProps(state) {
    return {
        modal: state.authState.login,
        route: state.appState.route,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        closeModal: () => {
            dispatch({ type: 'closeMiniModal' });
        },
        openRegistration: (onAfterRegistration) => {
            dispatch({
                type: 'openMiniModal',
                header: 'Регистрация',
                children: (
                    <RegistrationLink
                        onAfterRegistration={onAfterRegistration}
                    />
                ),
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        openReset: (e) => {
            e = e || window.event;
            e.preventDefault();
            dispatch({
                type: 'openMiniModal',
                header: 'Восстановить пароль',
                children: <ResetLink />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        dispatch,
    };
};

export const LoginLink = connect(MapStateToProps, mapDispatchToProps)(Login);
